module.exports = __webpack_public_path__ + "img/agoda.cbd4af63.svg";